import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20interior%20with%20dramatic%20red%20velvet%20curtains%20and%20warm%20golden%20spotlights%2C%20elegant%20classic%20cinema%20atmosphere%2C%20empty%20stage%20with%20movie%20screen%2C%20luxurious%20and%20grand%2C%20warm%20amber%20lighting%2C%20art%20deco%20details&width=1800&height=1200&seq=hero-bg-wukong&orientation=landscape"
          alt="悟空影视 - 免费在线观看高清电影电视剧"
          title="悟空影视 - 免费高清影视平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          悟空影视
        </h1>
        <p className="text-lg md:text-2xl text-white/90 font-body font-light mb-3 max-w-2xl">
          海量高清资源 即点即播 完全免费
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl">
          电影 · 电视剧 · 动漫 · 综艺 · 纪录片 —— 无需注册，打开就看，流畅不缓冲
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/movie"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始观影
          </Link>
          <Link
            to="/category/tv"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            热门电视剧
          </Link>
        </div>
      </div>
    </section>
  );
}